import { createContext } from 'react';

import { FilterAutoCompleteProps } from '@totem/components/common/filterAutoComplete/FilterAutoCompleteTypes';
import { BackupReportResponse } from '@totem/components/services/backup/deviceBackups/types';

interface Context {
  backupData: BackupReportResponse;
  loading: boolean;
  buildingFilter: FilterAutoCompleteProps;
  regionFilter: FilterAutoCompleteProps;
  deviceFilter: FilterAutoCompleteProps;
  onExport: () => void;
  isExporting: boolean;
}

export default createContext<Context>({
  backupData: null,
  loading: false,
  buildingFilter: null,
  regionFilter: null,
  deviceFilter: null,
  onExport: () => {},
  isExporting: false,
});
